import Vue from 'vue'
import VueRouter from 'vue-router'
// 服务
import Service from '../views/service.vue'
// 账户信息
import accountInformation from '../views/accountInformation'
// 发票
import Bill from '../views/bill/index'
// 发票详情
import BillDetails from '../views/bill/details'
// 报修
import Repair from '../views/repair/index'
// 登录
import Login from '../views/Login.vue'
// 注册
import Register from '../views/Register.vue'
// 重置
import Reset from '../views/resetPassword.vue'
// 户号管理
import AccountNumberManagement from '../views/accountNumberManagement/AccountNumberManagement.vue'
// 添加户号
import AddAccountNumber from '../views/accountNumberManagement/AddAccountNumber.vue'
// 核实地址
import VerifyAddress from '../views/accountNumberManagement/VerifyAddress.vue'
// 申报更正地址
import CorrectAddress from '../views/accountNumberManagement/CorrectAddress.vue'
// 查找用户编号
import FindUserNumber from '../views/accountNumberManagement/FindUserNumber.vue'
// 设备报修
import ReportRepair from '../views/repair/ReportRepair.vue'
// 我的报修
import MyRepair from '../views/repair/MyRepair.vue'
// 报修及巡检详情
import RepairDetail from '../views/repair/RepairDetail.vue'
// PC登录
import PCLogin from '../views/pc/Login'
// PC注册
import PCRegister from '../views/pc/Register'
// PC户号管理
import PCAccountNumberManagement from '../views/pc/accountNumberManagement/AccountNumberManagement'
// PC燃气户号管理-添加
import PCGasAccountManagement1 from '../views/pc/accountNumberManagement/GasAccountManagement1'
// PC燃气户号管理-添加2
import PCGasAccountManagement2 from '../views/pc/accountNumberManagement/GasAccountManagement2'
// PC燃气户号管理-添加3
import PCGasAccountManagement3 from '../views/pc/accountNumberManagement/GasAccountManagement3'
// PC燃气报修
import PCRepair from '../views/pc/Repair/Repair'
// PC燃气报修及巡检详情
import PCRepairDetail from '../views/pc/Repair/RepairDetail'
//pc我的报修
import PCMyRepair from '../views/pc/Repair/myRepair'
// PC燃气服务
import PCService from '../views/pc/Service'
// PC密码重置
import PCPasswordReset from '../views/pc/PasswordReset'
// PC燃气户号管理-查找用户编号
import PCFindingUserNo from '../views/pc/accountNumberManagement/FindingUserNo'
// PC燃气账户信息
import PCGasAccountInfo from '../views/pc/accountNumberManagement/GasAccountInfo'
// PC燃气发票
import PCGasInvoice from '../views/pc/gasInvoice/GasInvoice'
// PC燃气报修
import PCGasRepair from '../views/pc/Repair/GasRepair'
// PC燃气电子发票详情
import PCGasInvoiceDetail from '../views/pc/gasInvoice/GasInvoiceDetail'

Vue.use(VueRouter)

const originalReplace = VueRouter.prototype.replace

VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}

const routes = [
  // 登录
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  // 服务
  {
    path: '/',
    name: 'Service',
    component: Service
  },
  // 账户信息
  {
    path: '/accountInformation',
    name: 'accountInformation',
    component: accountInformation
  },
  // 发票
  {
    path: '/bill',
    name: 'Bill',
    component: Bill
  },
  // 发票详情
  {
    path: '/billDetails',
    name: 'BillDetails',
    component: BillDetails
  },
  // 报修
  {
    path: '/repair',
    name: 'Repair',
    component: Repair
  },
  // 注册
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  // 户号管理
  {
    path: '/accountNumberManagement',
    name: 'AccountNumberManagement',
    component: AccountNumberManagement
  },
  // 添加户号
  {
    path: '/addAccountNumber',
    name: 'AddAccountNumber',
    component: AddAccountNumber
  },
  // 核实地址
  {
    path: '/verifyAddress',
    name: 'VerifyAddress',
    component: VerifyAddress
  },
  // 申报更正地址
  {
    path: '/correctAddress',
    name: 'CorrectAddress',
    component: CorrectAddress
  },
  // 查找用户编号
  {
    path: '/findUserNumber',
    name: 'FindUserNumber',
    component: FindUserNumber
  },
  // 设备报修
  {
    path: '/reportRepair',
    name: 'ReportRepair',
    component: ReportRepair
  },
  // 我的报修
  {
    path: '/myRepair',
    name: 'MyRepair',
    component: MyRepair
  },
  // 报修及巡检详情
  {
    path: '/repairDetail',
    name: 'RepairDetail',
    component: RepairDetail
  },
  // 重置密码
  {
    path: '/reset',
    name: 'Reset',
    component: Reset
  },
  // PC登录
  {
    path: '/pcLogin',
    name: 'PCLogin',
    component: PCLogin
  },
  // PC注册
  {
    path: '/pcRegister',
    name: 'PCRegister',
    component: PCRegister
  },
  // PC户号管理
  {
    path: '/pcAccountNumberManagement',
    name: 'PCAccountNumberManagement',
    component: PCAccountNumberManagement
  },
  // PC燃气户号管理-添加
  {
    path: '/pcGasAccountManagement1',
    name: 'PCGasAccountManagement1',
    component: PCGasAccountManagement1
  },
  // PC燃气户号管理-添加2
  {
    path: '/pcGasAccountManagement2',
    name: 'PCGasAccountManagement2',
    component: PCGasAccountManagement2
  },
  // PC燃气户号管理-添加3
  {
    path: '/pcGasAccountManagement3',
    name: 'PCGasAccountManagement3',
    component: PCGasAccountManagement3
  },
  // PC燃气保修
  {
    path: '/pcRepair',
    name: 'PCRepair',
    component: PCRepair
  },
  // PC燃气保修
  {
    path: '/pcRepairDetail',
    name: 'PCRepairDetail',
    component: PCRepairDetail
  },
  // PC燃气服务
  {
    path: '/pcService',
    name: 'PCService',
    component: PCService
  },
  // PC燃气我的报修
  {
    path: '/pcMyRepair',
    name: 'PCMyRepair',
    component: PCMyRepair
  },
  // PC密码重置
  {
    path: '/pcPasswordReset',
    name: 'PCPasswordReset',
    component: PCPasswordReset
  },
  // PC燃气户号管理-查找用户编号
  {
    path: '/pcFindingUserNo',
    name: 'PCFindingUserNo',
    component: PCFindingUserNo
  },
  // PC燃气账户信息
  {
    path: '/pcGasAccountInfo',
    name: 'PCGasAccountInfo',
    component: PCGasAccountInfo
  },
  // PC燃气发票
  {
    path: '/pcGasInvoice',
    name: 'PCGasInvoice',
    component: PCGasInvoice
  },
  // PC燃气报修
  {
    path: '/pcGasRepair',
    name: 'PCGasRepair',
    component: PCGasRepair
  },
  // PC燃气电子发票详情
  {
    path: '/pcGasInvoiceDetail',
    name: 'PCGasInvoiceDetail',
    component: PCGasInvoiceDetail
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
